import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from './types';
import live from './live';

/**
 * 使用TypeScript+Vuex: https://juejin.cn/post/6844903901850763271
 */

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  modules: {
    live,
  },
};

export default new Vuex.Store<RootState>(store);
